import z from 'zod';

export const inviteSuccessStateSchema = z.object({
  email: z.string(),
  userId: z.string(),
  displayName: z.string(),
});
export type InviteSuccessState = z.infer<typeof inviteSuccessStateSchema>;
